export enum FeatureFlags {
  ENTITLEMENTS_USE_PRISM = 'portal-configure-entitlements-use-prism',
  APIHUB_WELCOME_BAR_MESSAGE_INDEX = 'api-hub-welcome-bar-message-index',
  MARKDOWN_EDITING_SUPPORT = 'portal-permanent-markdown-editing-support',
  FOOTER = 'portal-rollout-footer',
  HALO_AI_FEATURE_FLAG = 'halo-ai-api-hub-portal-generation',
  CKEDITOR_COLLABORATION_SUPPORT = 'portal-rollout-ck-editor-collaboration-plugins',
  HALO_AI_DOCUMENT_UPDATE = 'halo-ai-api-hub-portal-document-update',
  CKEDITOR_AUTOSAVE = 'portal-rollout-autosave',
  CKEDITOR_TRACK_CHANGES = 'portal-rollout-track-changes',
}

export type Flags = { [key in FeatureFlags]: boolean }